import { __exports as t } from "../../../../_virtual/focusManager.js";
import { t as s } from "./tabbable.js";
Object.defineProperty(t, "__esModule", {
  value: !0
});
t.resetState = f;
t.log = v;
t.handleBlur = r;
t.handleFocus = a;
t.markForFocusLater = m;
t.returnFocus = p;
t.popWithoutFocus = h;
t.setupScopedFocus = E;
t.teardownScopedFocus = F;
var l = s, i = d(l);
function d(e) {
  return e && e.__esModule ? e : { default: e };
}
var n = [], u = null, c = !1;
function f() {
  n = [];
}
function v() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), n.forEach(function(e) {
    var o = e || {};
    console.log(o.nodeName, o.className, o.id);
  }), console.log("end focusManager ----------"));
}
function r() {
  c = !0;
}
function a() {
  if (c) {
    if (c = !1, !u)
      return;
    setTimeout(function() {
      if (!u.contains(document.activeElement)) {
        var e = (0, i.default)(u)[0] || u;
        e.focus();
      }
    }, 0);
  }
}
function m() {
  n.push(document.activeElement);
}
function p() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = null;
  try {
    n.length !== 0 && (o = n.pop(), o.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", o, "but it is not in the DOM anymore"].join(" "));
  }
}
function h() {
  n.length > 0 && n.pop();
}
function E(e) {
  u = e, window.addEventListener ? (window.addEventListener("blur", r, !1), document.addEventListener("focus", a, !0)) : (window.attachEvent("onBlur", r), document.attachEvent("onFocus", a));
}
function F() {
  u = null, window.addEventListener ? (window.removeEventListener("blur", r), document.removeEventListener("focus", a)) : (window.detachEvent("onBlur", r), document.detachEvent("onFocus", a));
}
export {
  t as default
};
